/* eslint-disable */

import React from 'react'
import { Box, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material'

export interface UserYarnFormData {
  colorway_id: number
  dye_lot: string
  quantity: number
}

interface UserYarnFormDialogProps {
  open: boolean
  onClose: () => void
  onSubmit: () => void
  onBack?: () => void
  formData: UserYarnFormData
  onChange: (data: UserYarnFormData) => void
}

export default function UserYarnFormDialog({ open, onClose, onSubmit, onBack, formData, onChange }: UserYarnFormDialogProps) {
  const isAddDyeLot = formData.colorway_id > 0
  
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isAddDyeLot ? 'Add Dye Lot' : 'Add to Library'}</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <TextField
            label="Dye Lot (optional)"
            fullWidth
            value={formData.dye_lot}
            onChange={(e) => onChange({ ...formData, dye_lot: e.target.value })}
            sx={{ mb: 2 }}
            placeholder="Leave blank if unknown"
          />
          <TextField
            label="Quantity"
            type="number"
            fullWidth
            value={formData.quantity}
            onChange={(e) => onChange({ ...formData, quantity: parseInt(e.target.value) || 1 })}
            sx={{ mb: 2 }}
            inputProps={{ min: 1 }}
            required
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        {onBack && (
          <Button onClick={onBack}>Back</Button>
        )}
        <Button onClick={onSubmit} variant="contained">{isAddDyeLot ? 'Add Dye Lot' : 'Add to Library'}</Button>
      </DialogActions>
    </Dialog>
  )
}
